import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorElearningTopicVm } from '../operator-elearning-topic-vm.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningTopicsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningTopics`;
  }
  get(categoryId?: number, search?: string, categoryIds?: number[]): Observable<IOperatorElearningTopicVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (categoryId !== undefined && categoryId !== null) {
      params = params.set('categoryId', categoryId.toString());
    }
    if (search !== undefined && search !== null) {
      params = params.set('search', search);
    }
    if (categoryIds !== undefined && categoryIds !== null) {
      categoryIds.forEach((id) => {
        params = params.append('categoryIds', id.toString());
      });
    }
    return this.http.get<IOperatorElearningTopicVm[]>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
